import axios from "./api";

const PrisepsService =  {

    async searchByName(search) {
        const type = 'Прицеп';
        try {
            const response = await axios.get('/transport', {
                params: {
                    search: search,
                    tur_nomi: type,
                }
            });
            console.log('priseps', response.data);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport list';
        }
    },


    /**
     * data should look like this
     * {
     *   "tur_id": 2,
     *   "name": "Isuzu NQR",
     *   "davlat_raqam": "01A123BC",
     *   "tex_passport_raqam": "AC1234567",
     *   "rang": "Oq",
     *   "izoh": "Yangi keltirilgan transport (ixtiyoriy)"
     * }
     * @param data
     * @returns {Promise<any>}
     */
    async createPrisep(data) {
        const type = 'Прицеп';
        let turId = 0;
        let res = this.getTransportRoles();
        res.data?.forEach(role => {
            if (role.name === type) {
                data.tur_id = role.id;
                turId = role.id;
            }
        });
        try {
            const response = await axios.post('/transport', data);
            return response.data;
        }catch (error) {
            throw error.response?.data?.message || 'Error creating prisep';
        }
    },

    /**
     * response looks like this
     * {
     *   "success": true,
     *   "message": "success",
     *   "data": [
     *     {
     *       "id": 1,
     *       "name": "Yengil mashina",
     *       "created_at": "2024-01-01T12:00:00Z",
     *       "updated_at": "2024-01-01T12:00:00Z"
     *     }
     *   ]
     * }
     * @returns {Promise<any>}
     */
    async getTransportRoles(){
        try {
            const response = await axios.get('/transport_tur');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting transport list';
        }
    }
}

export default PrisepsService